<div class="row mb-3">
  <div class="col-2">
    <h5>Bulk Action{{ selectedCount ? ' (' + selectedCount + ')' : '' }}</h5>
    <button type="button" (click)="deleteSelected()" class="btn btn-danger btn-sm me-1" [disabled]="selectedCount == 0">Delete</button>
    <button type="button" (click)="updateSelected()" [disabled]="selectedCount == 0" class="btn btn-light btn-sm">Update</button>
  </div>
  <div class="col-4">
    <h5 class="mx-2">Distribution</h5>
    <div *ngIf="count" class="table-responsive">
      <table class="table">
        <tbody>
          <tr>
            <td>Total</td>
            <td>{{ count.total }}</td>
          </tr>
          <tr>
            <td>Active</td>
            <td>{{ count.active }}</td>
          </tr>
          <tr>
            <td>Expired</td>
            <td>{{ count.expired }}</td>
          </tr>
          <tr>
            <td>Disabled</td>
            <td>{{ count.disabled }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="col-6">
    <h5>Filter{{ filtered.length === entries.length ? '' : ' (' + filtered.length + ')' }}</h5>
    <div class="form-group row mb-1">
      <label for="username-select" class="col-3 col-form-label">Username</label>
      <div class="col-9">
        <input class="form-control" id="username-select" type="text" [(ngModel)]="filter.username" (ngModelChange)="updateFiltered()" />
      </div>
    </div>
    <div class="form-group row mb-1">
      <label for="mail-select" class="col-3 col-form-label">Mail</label>
      <div class="col-9">
        <input class="form-control" id="mail-select" type="text" [(ngModel)]="filter.mail" (ngModelChange)="updateFiltered()" />
      </div>
    </div>
    <div class="form-group row mb-1">
      <label for="role-select" class="col-3 col-form-label">Role</label>
      <div class="col-9">
        <select class="form-select" id="role-select" [(ngModel)]="filter.role" (ngModelChange)="updateFiltered()">
          <option value="*">All</option>
          <option *ngFor="let r of roles" [value]="r.name">{{ r.name }}</option>
        </select>
      </div>
    </div>
    <div class="form-group row mb-1" *ngIf="licences?.length > 0">
      <label for="licence-select" class="col-3 col-form-label">Licence</label>
      <div class="col-9">
        <select class="form-select" id="licence-select" [(ngModel)]="filter.licence" (ngModelChange)="updateFiltered()">
          <option value="*">All</option>
          <option *ngFor="let l of licences" [value]="l">{{ l }}</option>
        </select>
      </div>
    </div>
    <div class="form-group row mb-1">
      <label for="expiry-select" class="col-3 col-form-label">Expiry</label>
      <div class="col-9">
        <select class="form-select" id="expiry-select" [(ngModel)]="filter.expiry" (ngModelChange)="updateFiltered()">
          <option class="dropdown-item" value="any">Any</option>
          <option class="dropdown-item" value="active">Active</option>
          <option class="dropdown-item" value="expired">Expired</option>
          <option class="dropdown-item" value="disabled">Disabled</option>
        </select>
      </div>
    </div>
    <div class="form-group row mb-1" *ngIf="labelKeys">
      <label class="col-3 col-form-label">Label</label>
      <div class="col-4">
        <select class="form-select" id="label-key-select" [(ngModel)]="filterLabelKey" (ngModelChange)="updateFiltered()">
          <option value="*"></option>
          <option *ngFor="let key of labelKeys" [value]="key">{{ key }}</option>
        </select>
      </div>
      <label class="col-1 col-form-label text-center">=</label>
      <div class="col-4">
        <select
          class="form-select"
          id="label-value-select"
          [disabled]="filterLabelKey === '*'"
          [(ngModel)]="filter.labelValue"
          (ngModelChange)="updateFiltered()"
        >
          <option value="*"></option>
          <option *ngFor="let value of labelValues[filterLabelKey] ?? []" [value]="value">{{ value }}</option>
        </select>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <table class="table table-hover">
      <thead class="text-primary">
        <tr>
          <th style="width: 20px">
            <input
              type="checkbox"
              class="form-check"
              id="check-all-user"
              (change)="selectAll($event.target.checked)"
              [checked]="allSelected"
            />
          </th>
          <th *ngIf="columns.uuid" class="clickable" (click)="toggleSort('uuid')">
            UUID
            <fa-icon *ngIf="sortingKey === 'uuid' && !sortingReverse" [icon]="['fal','caret-up']"></fa-icon>
            <fa-icon *ngIf="sortingKey === 'uuid' && sortingReverse" [icon]="['fal','caret-down']"></fa-icon>
          </th>
          <th *ngIf="columns.username || columns.pattern" class="clickable" (click)="toggleSort('username')">
            <span *ngIf="columns.username"> Username </span>
            <span *ngIf="columns.pattern && columns.username"> / </span>
            <span *ngIf="columns.pattern"> Pattern </span>
            <fa-icon *ngIf="sortingKey === 'username' && !sortingReverse" [icon]="['fal','caret-up']"></fa-icon>
            <fa-icon *ngIf="sortingKey === 'username' && sortingReverse" [icon]="['fal','caret-down']"></fa-icon>
          </th>
          <th *ngIf="columns.licence" class="clickable" (click)="toggleSort('licence')">
            Licence Key
            <fa-icon *ngIf="sortingKey === 'licence' && !sortingReverse" [icon]="['fal','caret-up']"></fa-icon>
            <fa-icon *ngIf="sortingKey === 'licence' && sortingReverse" [icon]="['fal','caret-down']"></fa-icon>
          </th>
          <th *ngIf="columns.usage">Usage</th>
          <th *ngIf="columns.activations" class="clickable" (click)="toggleSort('activations')">
            Activations
            <fa-icon *ngIf="sortingKey === 'activations' && !sortingReverse" [icon]="['fal','caret-up']"></fa-icon>
            <fa-icon *ngIf="sortingKey === 'activations' && sortingReverse" [icon]="['fal','caret-down']"></fa-icon>
          </th>
          <th *ngIf="columns.fullname" class="clickable" (click)="toggleSort('fullname')">
            Name
            <fa-icon *ngIf="sortingKey === 'fullname' && !sortingReverse" [icon]="['fal','caret-up']"></fa-icon>
            <fa-icon *ngIf="sortingKey === 'fullname' && sortingReverse" [icon]="['fal','caret-down']"></fa-icon>
          </th>
          <th *ngIf="columns.mail" class="clickable" (click)="toggleSort('mail')">
            Mail
            <fa-icon *ngIf="sortingKey === 'mail' && !sortingReverse" [icon]="['fal','caret-up']"></fa-icon>
            <fa-icon *ngIf="sortingKey === 'mail' && sortingReverse" [icon]="['fal','caret-down']"></fa-icon>
          </th>
          <th *ngIf="columns.labels">Labels</th>
          <th *ngIf="columns.roles" class="clickable" (click)="toggleSort('roles')">
            Roles
            <fa-icon *ngIf="sortingKey === 'roles' && !sortingReverse" [icon]="['fal','caret-up']"></fa-icon>
            <fa-icon *ngIf="sortingKey === 'roles' && sortingReverse" [icon]="['fal','caret-down']"></fa-icon>
          </th>
          <th *ngIf="columns.registered" class="clickable" (click)="toggleSort('registered')">
            Registered
            <fa-icon *ngIf="sortingKey === 'registered' && !sortingReverse" [icon]="['fal','caret-up']"></fa-icon>
            <fa-icon *ngIf="sortingKey === 'registered' && sortingReverse" [icon]="['fal','caret-down']"></fa-icon>
          </th>
          <th *ngIf="columns.created" class="clickable" (click)="toggleSort('created')">
            Created
            <fa-icon *ngIf="sortingKey === 'created' && !sortingReverse" [icon]="['fal','caret-up']"></fa-icon>
            <fa-icon *ngIf="sortingKey === 'created' && sortingReverse" [icon]="['fal','caret-down']"></fa-icon>
          </th>
          <th *ngIf="columns.expiry" class="clickable" (click)="toggleSort('expiry')">
            Expires
            <fa-icon *ngIf="sortingKey === 'expiry' && !sortingReverse" [icon]="['fal','caret-up']"></fa-icon>
            <fa-icon *ngIf="sortingKey === 'expiry' && sortingReverse" [icon]="['fal','caret-down']"></fa-icon>
          </th>
          <th class="text-right">Action</th>
          <th style="width: 0">
            <fa-icon [icon]="['fal','cog']" class="clickable" (click)="showColumFilterModal()"></fa-icon>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          class="table-row"
          *ngFor="let entry of sorted | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize"
          [class.table-active]="selection[entry.uuid]"
        >
          <td>
            <input
              type="checkbox"
              class="form-check"
              [id]="'check-user-' + entry.uuid"
              (change)="select(entry.uuid, $event.target.checked)"
              [checked]="selection[entry.uuid]"
            />
          </td>

          <td *ngIf="columns.uuid">{{ entry.uuid }}</td>
          <td *ngIf="columns.username || columns.pattern">
            <div *ngIf="columns.username && entry.username">{{ entry.username }}</div>
            <div *ngIf="columns.pattern && entry.pattern">
              <div class="pattern highlight" [ngbTooltip]="entry.patternTooltip" placement="right">{{ entry.pattern }}</div>
            </div>
          </td>
          <td *ngIf="columns.licence">{{ entry.key }}</td>
          <td *ngIf="columns.usage">
            <div [ngbTooltip]="licenceUsageInfo[entry.usage]" placement="right">{{ entry.usage }}</div>
          </td>
          <td *ngIf="columns.activations">
            <span>{{ entry.activations || 0 }}</span>
            <span *ngIf="entry.volume"> / {{ entry.volume }}</span>
          </td>
          <td *ngIf="columns.fullname">
            {{ entry.prf.settings.title }} {{ entry.prf.settings.firstname }} {{ entry.prf.settings.lastname }}
          </td>
          <td *ngIf="columns.mail">{{ entry.prf.meta.mail }}</td>
          <td *ngIf="columns.labels" style="max-width: 12vw">{{ entry.labelsText }}</td>
          <td *ngIf="columns.roles">
            <div [ngbTooltip]="entry.rolesTooltip" placement="left">
              <ng-container *ngFor="let role of entry.roles; let last = last">
                <span *ngIf="!role.licences || role.licences.length == 0" class="role">{{ role.role }}</span>
                <span *ngIf="role.licences?.length > 0" class="highlight">{{ role.role }}</span>
                <span *ngIf="!last">, </span>
              </ng-container>
            </div>
          </td>
          <td *ngIf="columns.created">{{ entry.created | date:dateFormat }}</td>
          <td *ngIf="columns.registered">{{ entry.prf.meta?.registration | date:dateFormat }}</td>
          <td *ngIf="columns.expiry">
            <div *ngIf="entry.state === State.active">
              <span *ngIf="entry.expiry?.licence" class="highlight" ngbTooltip="Pending licence expiration">{{ entry.expiry?.text }}</span>
              <span *ngIf="!entry.expiry?.licence">{{ entry.expiry?.text }}</span>
            </div>
            <div *ngIf="entry.state === State.expired" class="text-warning">{{ entry.expiry?.text }}</div>
            <div *ngIf="entry.state === State.disabled" class="text-warning">disabled</div>
            <div *ngIf="entry.state === State.noperms" class="text-danger">no roles</div>
          </td>
          <td colspan="2" class="text-right text-nowrap">
            <span class="btn-wrapper" placement="top" [ngbTooltip]="canEdit? 'Edit':'Insufficent permission'" container="body">
              <button type="button" class="btn btn-sm btn-light me-1" (click)="updateEntry(entry)" placement="left" [disabled]="!canEdit">
                <fa-icon [icon]="['fal','cog']" [fixedWidth]="true"></fa-icon>
              </button>
            </span>
            <span
              class="btn-wrapper"
              placement="top"
              [ngbTooltip]="canEdit ? (entry.prf.enabled ? 'Click to disable' : 'Click to enable') : 'Insufficient permission'"
              container="body"
            >
              <button
                type="button"
                class="btn btn-sm me-1"
                [ngClass]="entry.prf.enabled ? 'btn-success' : 'btn-warning'"
                (click)="toggleState(entry)"
                placement="left"
                [disabled]="!canEdit"
              >
                <fa-icon [icon]="entry.prf.enabled ? ['fal','user'] : ['fal','user-slash']" [fixedWidth]="true" class="fa-fw"></fa-icon>
              </button>
            </span>
            <span class="btn-wrapper" placement="top" [ngbTooltip]="canDelete? 'Delete':'Insufficent permission'" container="body">
              <button (click)="deleteEntry(entry)" type="button" class="btn btn-danger btn-sm" placement="left" [disabled]="!canDelete">
                <fa-icon [icon]="['fal','trash']" [fixedWidth]="true"></fa-icon>
              </button>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
    <ngb-pagination
      *ngIf="sorted.length > pageSize"
      [(page)]="page"
      [pageSize]="pageSize"
      [collectionSize]="filtered.length"
      [maxSize]="5"
      [boundaryLinks]="true"
    ></ngb-pagination>
  </div>
</div>
